module.exports = __webpack_public_path__ + "img/pointGuessing_bg.35683163.png";